import { getDocumentPreviewURL } from '@/features/documents/api/documents.service'
import { getFileFormat, isMicrosoftDocument, MSFT_VIEWER_EMBED_URL } from '@/utils/documentPreview'

/**
 * Creates a Microsoft Office viewer URL for a document if it's a Microsoft document
 * @param documentId - The ID of the document
 * @param fileName - The name of the file to check format
 * @returns Promise<string> - The Microsoft viewer URL with embedded preview URL
 */
export const createMicrosoftPreviewUrl = async (documentId: string, fileName: string): Promise<string> => {
  const fileFormat = getFileFormat(fileName)

  if (!isMicrosoftDocument(fileFormat)) {
    throw new Error('Document is not a Microsoft Office document')
  }

  const { previewUrl } = await getDocumentPreviewURL(documentId)
  return `${MSFT_VIEWER_EMBED_URL}${encodeURIComponent(previewUrl)}`
}

/**
 * Checks if a document is a Microsoft document and creates the appropriate preview URL
 * @param documentId - The ID of the document
 * @param fileName - The name of the file to check format
 * @returns Promise<string | null> - The Microsoft viewer URL or null if not a Microsoft document
 */
export const getMicrosoftPreviewUrlIfApplicable = async (
  documentId: string,
  fileName: string
): Promise<string | null> => {
  const fileFormat = getFileFormat(fileName)

  if (isMicrosoftDocument(fileFormat)) {
    return await createMicrosoftPreviewUrl(documentId, fileName)
  }

  return null
}
